//忘记密码
import request from '@/utils/request'

export function webForgetPassword(password, phone) {
    return request.post('/login/webForgetPassword?password=' + password + '&phone=' + phone)
}